import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import AccionaBigUploadButton from '../../../../../components/AccionaBigUploadButton';
import {
  deliveryNotesFileExtensions,
  laboratoryFileExtensions,
} from '../../../../../constants/general';
import Modal from '../../../../../components/Modal';
import styles from './index.module.scss';

const { buttons } = styles;

const UploadDocumentModal = ({
  open,
  onSingleFileUpload,
  onMultipleFilesUpload,
  onCancel,
}) => {
  const intl = useIntl();

  const fileSelectedHandler = async (event, model, ref) => {
    const files = event.target.files;
    const allowedFileExtensions =
      model === 'delivery'
        ? deliveryNotesFileExtensions
        : laboratoryFileExtensions;
    const firstFileExtension = files?.[0].name.split('.').pop();
    const isASingleXlsxFile =
      files?.length === 1 && firstFileExtension === 'xlsx';

    if (files?.length === 1 && !isASingleXlsxFile) {
      onSingleFileUpload(files[0], allowedFileExtensions, model);
    } else if (files?.length > 1 || isASingleXlsxFile) {
      onMultipleFilesUpload(files, model, ref);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width="50vw"
      backgroundColor="#f1f1f1"
      closable
    >
      <div className={buttons}>
        <AccionaBigUploadButton
          icon="delivery-ocr"
          type="deliveryNote"
          id="uploadDelivery"
          onClick={(event) =>
            fileSelectedHandler(event, 'delivery', `fileSelector_delivery-ocr`)
          }
          msg={intl.formatMessage({ id: `scan.document.delivery` })}
        />
        <AccionaBigUploadButton
          icon="delivery-ocr"
          type="deliveryNote"
          id="uploadDeliveryPC"
          onClick={(event) =>
            fileSelectedHandler(
              event,
              'deliveryPC',
              `fileSelector_deliveryPC-ocr`,
            )
          }
          msg={intl.formatMessage({ id: `scan.document.deliveryPC` })}
        />
        <AccionaBigUploadButton
          icon="laboratory-ocr"
          type="laboratory"
          id="uploadLaboratory"
          onClick={(event) =>
            fileSelectedHandler(
              event,
              'laboratory',
              `fileSelector_laboratory-ocr`,
            )
          }
          msg={intl.formatMessage({ id: `scan.document.laboratory` })}
        />
      </div>
    </Modal>
  );
};

UploadDocumentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSingleFileUpload: PropTypes.func.isRequired,
  onMultipleFilesUpload: PropTypes.func.isRequired,
};

export default UploadDocumentModal;
